// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M8 3V8M8 8V13M8 8H13M8 8H3'];
